if (!customElements.get('herrina-ring-size')) {
  customElements.define('herrina-ring-size', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.form = this.closest('form');
      if (!this.select || !this.form) return;
      const quantity = this.closest('product-info')?.querySelector('.product-form__quantity');
      if (quantity?.querySelector('[name="quantity"]')?.form === this.form) this.after(quantity);
      this.error = this.querySelector('[data-size-error]');
      this.changeHandler = () => {
        this.error.hidden = true;
        this.select.removeAttribute('aria-invalid');
        this.updateCheckout();
      };
      this.submitHandler = (event) => {
        if (this.validSize()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.error.hidden = false;
        this.select.setAttribute('aria-invalid', 'true');
        this.select.focus();
      };
      this.select.addEventListener('change', this.changeHandler);
      this.form.addEventListener('submit', this.submitHandler, true);
      this.updateCheckout();
    }
    disconnectedCallback() {
      this.select?.removeEventListener('change', this.changeHandler);
      this.form?.removeEventListener('submit', this.submitHandler, true);
    }
    validSize() {
      const value = Number(this.select.value);
      return this.select.value !== '' && value >= 3 && value <= 13 && Number.isInteger(value * 4);
    }
    updateCheckout() {
      const missing = !this.validSize();
      this.form.toggleAttribute('data-herrina-size-missing', missing);
      this.form.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = missing; });
    }
  });
}
